exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.btn-position-wrapper {\n    top: 0;\n    right: 1rem;\n}\n", ""]);

// exports
